export const generatePDFIds = {
    dashboard: () => 'dashboard',
    chart: (index: number) => `chart${index}`,
    exportTarget: (name: string) => name,
    table: (name: string) => `${name}Table`,
}
